export default __webpack_public_path__ + "static/media/icon_THird_party_motor.1b67fd39.png";